import Accordion from "./ui/Accordion";
import Section from "./ui/Section";

export default function FAQ() {
  const faqs = [
    {
      q: "What is CaratPay?",
      a: "CaratPay is a fintech platform built exclusively for retail jewellers. We provide infrastructure to support metal booking and white-labelled gold and silver savings schemes through a single integrated system.",
    },
    {
      q: "Is CaratPay a digital gold or investment platform?",
      a: "No. CaratPay does not sell digital gold, offer investment products, or promise returns. We operate as a technology and execution platform for jewellers.",
    },
    {
      q: "Who can use CaratPay?",
      a: "CaratPay is available only to registered retail jewellers. End customers interact with their jeweller, not directly with CaratPay.",
    },
    {
      q: "How does the metal booking platform work?",
      a: "Jewellers can book gold or silver metal at prevailing market-linked prices through CaratPay. Metal booking is executed through our authorised third-party supply partner BRPL, either for inventory or against customer purchase plan collections.",
    },
    {
      q: "How do gold and silver savings schemes work on CaratPay?",
      a: "Jewellers can launch white-labelled gold and silver savings schemes for their customers. Customer payments are collected digitally, and corresponding metal bookings are executed on behalf of the jeweller pursuant to customer authorisation.",
    },
    {
      q: "Who owns the gold or silver booked through CaratPay?",
      a: "All metal bookings are made on behalf of the participating jeweller. CaratPay does not claim ownership of the gold or silver at any point.",
    },
    {
      q: "Is physical delivery of metal available?",
      a: "Yes. Jewellers can request physical delivery of gold or silver metal booked through the platform.",
    },
    {
      q: "What is the shipping and delivery timeline?",
      a: "For Tier 1 cities, metal delivery to the jeweller’s registered address is typically completed within 2–3 business days from the date of a confirmed delivery request. Delivery timelines may vary based on location and logistics conditions.",
    },
    {
      q: "Can jewellers opt for self-pickup instead of doorstep delivery?",
      a: "Yes. Subject to availability and partner policies, jewellers may opt for self-pickup at designated locations.",
    },
    {
      q: "Can a metal booking be cancelled?",
      a: "No. Once a metal booking is executed through the third-party supply partner, it cannot be cancelled, as the metal is booked at live market prices and settled immediately.",
    },
    {
      q: "Is a refund possible after booking gold or silver?",
      a: "No. Due to the nature of metal booking and immediate market settlement, refunds are not possible once a booking has been executed.",
    },
    {
      q: "What happens if a customer wants to exit a purchase plan?",
      a: "Exit, redemption, or adjustment terms are governed by the jeweller’s purchase plan rules. CaratPay facilitates the operational workflow but does not determine scheme terms.",
    },
    {
      q: "Does CaratPay guarantee metal prices or availability?",
      a: "No. Metal prices are market-linked, and availability is subject to supply partner conditions at the time of booking.",
    },
    {
      q: "Is CaratPay regulated?",
      a: "CaratPay operates as a technology and service provider, working with authorised payment and metal supply partners and complying with applicable commercial, tax, and operational laws.",
    },
    {
      q: "How does CaratPay ensure transparency?",
      a: "The platform provides detailed transaction records, booking confirmations, and delivery status updates for jewellers to maintain clear audit trails.",
    },
  ];

  return (
    <Section className="bg-[#fdfaf2] dark:bg-[#111111]">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-4xl font-bold text-[#1a1a1a] dark:text-white mb-12 text-center">
          Frequently Asked Questions
        </h2>
        <div className="bg-white dark:bg-[#0a0a0a] rounded-3xl p-8 border border-[#C9A227]/10 shadow-sm">
          {faqs.map((faq) => (
            <Accordion key={faq.q} title={faq.q}>
              {faq.a}
            </Accordion>
          ))}
        </div>
      </div>
    </Section>
  );
}
